import { Suspense, lazy } from 'react';

import { ProgressCircle } from '@spotify-internal/encore-web';

import type { RecordingHit } from './types';

const RecordingsCarousel = lazy(() =>
  import('./RecordingsCarousel').then(module => ({
    default: module.RecordingsCarousel,
  })),
);

export const RecordingsResult = ({
  recordings,
}: {
  recordings: RecordingHit[];
}): JSX.Element | null =>
  recordings.length === 0 ? null : (
    <Suspense
      fallback={
        <ProgressCircle size="small" aria-label="Loading recording previews" />
      }
    >
      <RecordingsCarousel recordings={recordings} />
    </Suspense>
  );
